import type { AsyncState } from '@essent/common';
import {
  createAsyncStateReducer,
  createInitialAsyncState,
} from '@essent/common';
import type { Action, ActionReducerMap } from '@ngrx/store';
import { combineReducers } from '@ngrx/store';
import type {
  GetAddressinfoV1Response,
  PostSolarpanelV1Response,
} from '@integration/api-client/feh';
import { FehApiActions, MeteringApiActions } from '@feh/shared-api';
import type { GetHouseTypeExpectedConsumptionV1Response } from '@integration/api-client/metering';

export const solarPanelsApiKey = 'solarPanelsAPI';

export type PostSolarPanelsNewCustomerConfirmationState = AsyncState<void>;
export interface SolarPanelsAPIState {
  getSolarPanelsAddressCheck: AsyncState<GetAddressinfoV1Response>;
  postSolarPanelsCreateLead: AsyncState<PostSolarpanelV1Response>;
  getExpectedConsumption: AsyncState<GetHouseTypeExpectedConsumptionV1Response>;
}

export const initialSolarPanelsAPIState: SolarPanelsAPIState = {
  getSolarPanelsAddressCheck: createInitialAsyncState(),
  postSolarPanelsCreateLead: createInitialAsyncState(),
  getExpectedConsumption: createInitialAsyncState(),
};

const getSolarPanelsAddressCheckReducer = createAsyncStateReducer(
  FehApiActions.getAddressinfoV1
);

const _reducers: ActionReducerMap<SolarPanelsAPIState, Action> = {
  getSolarPanelsAddressCheck: getSolarPanelsAddressCheckReducer,
  postSolarPanelsCreateLead: createAsyncStateReducer(
    FehApiActions.postSolarpanelV1
  ),
  getExpectedConsumption: createAsyncStateReducer(
    MeteringApiActions.getHouseTypeExpectedConsumptionV1
  ),
};

const _combinedReducers = combineReducers(_reducers);
export const solarPanelsAPIReducer = (
  state: SolarPanelsAPIState = initialSolarPanelsAPIState,
  action: Action
): SolarPanelsAPIState => _combinedReducers(state, action);
